<!-- Cookie Bar -->
@if(showCookieBar){
<div class="cookie-bar">
  <div class="flex justify-between sm:mx-18 text-[14px] tracking-tight">
    <div class="flex flex-col w-full">
      <p class="text-xl font-bold text-black">We value your privacy</p>

      <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 sm:gap-10 mt-2">
        <p class="text-black flex-1">
          We use functional cookies to ensure our website works properly and to improve your experience.
          These cookies are essential for the basic functionality of our site.
          <a href="#" class="text-blue-400 underline ml-2 cursor-pointer"
            (click)="openPopup(); $event.preventDefault()">Show more</a>
        </p>

        <button mat-flat-button class="acknowledge-btn mt-2 sm:mt-0" [color]="'primary'" (click)="acknowledgeCookies()">
          Got it
        </button>
      </div>
    </div>
  </div>
</div>
}


<!-- Popup Overlay -->
@if(showPopup){
<div class="popup-overlay" tabindex="1" (click)="onOverlayClick($event)">
  <div class="popup-content">
    <div class="popup-header">
      <h3>Cookie Information</h3>
      <button class="close-btn" (click)="closePopup()">&times;</button>
    </div>

    <div class="popup-body text-xs">
      <h2>Third Party Cookies</h2>
      <p>
        These cookies assist with processing payments via Stripe. Detailed information about each cookie is provided below.
      </p>

      <p>
        The cookies that are categorised as "Necessary" are stored on your browser as they are essential for enabling
        the basic functionalities of the site.
      </p>

      <div class="mb-4">
        <button (click)="toggleNecessary()"
          class="flex items-center justify-between w-full text-left text-[#2c3e50] text-lg focus:outline-none">
          <div class="flex items-center gap-2 font-bold">
            <svg [ngClass]="{ 'rotate-180': showNecessary }" class="w-5 h-5 transition-transform duration-200"
              fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7"></path>
            </svg>
            <span>Necessary</span>
          </div>
          <span class="text-green-500 font-semibold">Always Active</span>
        </button>

        <p class="mt-4 ml-6 text-xs text-gray-600">
          Necessary cookies are required to enable the basic features of this site, such as providing secure log-in.
          These cookies do not store any personally identifiable data.
        </p>
      </div>

      @if(showNecessary){
      @for(cookie of necessaryCookies; track cookie.cookie){
      <div class="space-y-6 ml-6 bg-cyan-50 p-2">
        <div class="space-y-1">
          <div class="grid grid-cols-[120px_1fr] text-xs">
            <span class="font-semibold text-gray-700">Cookie</span>
            <span class="text-gray-700">{{cookie.cookie}}</span>

            <span class="font-semibold text-gray-700">Duration</span>
            <span class="text-gray-700">{{cookie.duration}}</span>

            <span class="font-semibold text-gray-700">Description</span>
            <span class="text-gray-700">
              {{cookie.description}}
            </span>
          </div>
        </div>
      </div>
      }
      }
    </div>

    <div class="popup-footer">
      <button mat-flat-button class="close-popup-btn" [color]="'primary'" (click)="closePopup()">Close</button>
    </div>
  </div>
</div>
}